
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';

export default {
  name: 'headless-page',
  mixins: [sulu],
};
